"use client";

import { cn } from "@rivval/css";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@rivval/ui/accordion";

import type { FeaturedAccordionData } from "~/types/data";

interface FeaturedAccordionContentProps {
  data: FeaturedAccordionData[];
  backgroundColor?: string;
  title?: string;
}

export function FeaturedAccordionContent({
  data,
  backgroundColor = "bg-black",
  title = "FAQ",
}: FeaturedAccordionContentProps) {
  return (
    <section className={cn("razor-top py-20", backgroundColor)} id="faq">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <span className="font-mono text-sm text-yellow-400">
            MODE.CONTACT_08457 : : : : : 01100110 01100001 01110001 :::::::::::
            8.2.0
          </span>
        </div>
        <div className="faq">
          <h3 className="h3 section-title mb-8 text-4xl font-bold text-yellow-400">
            {title}
          </h3>
          <Accordion type="single" collapsible className="w-full">
            {data.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-yellow-400/30"
              >
                <AccordionTrigger className="hover:no-underline">
                  <div className="flex items-center">
                    <span className="mr-4">
                      <svg
                        width="32"
                        height="33"
                        viewBox="0 0 36 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="transform transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-90"
                      >
                        <path
                          className="arrow"
                          d="M25.3718 18.872L17.9558 25.976H14.6678L20.8838 20.024H10.0118V17.696H20.9558L14.6438 11.72H17.9558L25.3718 18.872Z"
                          fill="#D9D9D9"
                        />
                        <path
                          d="M35 2V1H34H6.67213H6.25507L5.9616 1.29634L1.28947 6.01408L1 6.30637V6.71774V35V36H2H34H35V35V2Z"
                          stroke="#D9D9D9"
                          strokeWidth="2"
                        />
                      </svg>
                    </span>
                    <p className="text-left text-white">{item.question}</p>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-md pl-16 text-black">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
